import React from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

const statusColor = {
  ClockIn: "bg-green-500",
  BreakIn: "bg-green-500",
  LunchIn: "bg-green-500",
  BreakOut: "bg-yellow-500",
  LunchOut: "bg-yellow-500",
  ClockOut: "bg-red-500",
};

type UserStatus = "ClockIn" | "BreakIn" | "LunchIn" | "BreakOut" | "LunchOut" | "ClockOut";

interface User {
  name: string;
  last_name: string;
  alias?: string;
  photo: string;
  isBirthday: boolean;
  is_head: boolean;
  id: number;
  status: UserStatus;
}

const UserCard = ({ user, onChat }: { user: User; onChat?: (user: User) => void }) => {
  const fullName = `${user.name} ${user.last_name}`;
  const displayName = user.alias?.trim() ? user.alias : fullName;
  const colorClass = statusColor[user.status] || "bg-gray-300";

  return (
    <View className="items-center w-24 mx-2 mb-5">
      <View className="relative">
        <Image
          source={{ uri: user.photo }}
          className="w-20 h-20 rounded-full"
        />
        {user.isBirthday && (
          <View className="absolute inset-0 bg-pink-200 opacity-30 rounded-full" />
        )}
        <View
          className={`absolute bottom-0 right-0 w-6 h-6 rounded-full ${colorClass} border border-white`}
        />
      </View>
      <Text className="text-xs text-center mt-1">{displayName}</Text>
    </View>
  );
};

export default UserCard;
